import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	/*fetchPortfolioSettings,*/ fetchPortfolioSettingsByPropertyId,
	setNotification,
	setAllNotificationsByPortfolioId /*, removeProperty*/,
} from 'reducers/portfolioSettingsReducer';
// import { fetchPortfolioSettingsByPropertyId, setNotification } from 'reducers/portfolioSettingsReducer';
// import { fetchPortfolio } from 'reducers/portfolioReducer';
// import { closeModal } from 'reducers/modalReducer';
// import StandardModal from 'modals/StandardModal';
import Spinner from 'components/Spinner';
// import Toggle from 'components/Toggle';

import './AlertsList.css';

const AlertsList = ({ showAddress }) => {
	const dispatch = useDispatch();
	// const { portfolioId } = options; //todo: how to get this?
	const { portfolioSettings, isLoading, propertyData, userId } = useSelector(
		(state) => ({
			isLoading:
				state.portfolioSettings.isLoading ||
				state.portfolioSettings.isRemovingProperty,
			portfolioSettings: state.portfolioSettings.data || {},
			propertyData: state.property.propertyData,
			userId: state.user.userData?.id,
			propertyInPortfolio: state.portfolio.propertyInPortfolio,
		})
	);

	const isLoggedIn = !!userId;

	//this is used because each checkbox needs a unique html id, but multiple copies of this component can be rendered simultaneously
	const instanceId = useRef(Math.random());

	//this is needed because pusher/websocket notifications can trigger reloading the property data
	// we don't want to re-fetch the portfolio settings when pusher re-fetches the same property
	const [currentPropId, setCurrentPropId] = useState(null);

	//we have to track changes to the notification state locally because the api doesn't return anything on success
	const [notificationsState, setNotificationsState] = useState({});
	const [isAllSelected, setIsAllSelected] = useState(false);

	useEffect(() => {
		let initialState = {};
		let allSelected = true;
		portfolioSettings.notificationTypes?.forEach((notificationType) => {
			initialState[notificationType.id] = notificationType.enabled === 1;
			if (notificationType.enabled !== 1) {
				allSelected = false;
			}
		});
		setNotificationsState(initialState);
		setIsAllSelected(allSelected);
	}, [portfolioSettings.notificationTypes]);

	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(() => {
		if (isLoggedIn && propertyData?.id && propertyData.id !== currentPropId) {
			setCurrentPropId(propertyData?.id);
			dispatch(fetchPortfolioSettingsByPropertyId(propertyData?.id));
		}
	}, [propertyData, userId, dispatch]);

	const onSelectAll = (ev) => {
		let shouldEnable = ev.target.checked;

		let newState = { ...notificationsState };
		portfolioSettings.notificationTypes?.forEach((notificationType) => {
			newState[notificationType.id] = shouldEnable;
		});
		setNotificationsState(newState);
		setIsAllSelected(shouldEnable);

		dispatch(
			setAllNotificationsByPortfolioId(portfolioSettings.id, shouldEnable)
		);
	};

	const handleToggle = (ev, notificationId) => {
		let shouldEnable = ev.target.checked;
		let newState = Object.assign({}, notificationsState);
		newState[notificationId] = shouldEnable;
		setNotificationsState(newState);

		let allSelected = true;
		portfolioSettings.notificationTypes?.forEach((notificationType) => {
			if (!newState[notificationType.id]) {
				allSelected = false;
			}
		});
		setIsAllSelected(allSelected);

		dispatch(
			setNotification(portfolioSettings.id, notificationId, shouldEnable)
		);
	};

	const getLabel = (notificationType) => {
		let labelText = notificationType?.name;
		return labelText;
	};

	if (isLoading) {
		return (
			<div className="alerts-list d-flex justify-content-center w-100">
				<Spinner />
			</div>
		);
	}

	return (
		<div className="alerts-list">
			{showAddress && <h6>{propertyData?.address}</h6>}
			{/*<div className="mb-2">Notifications:</div>*/}
			<div>
				<div className="notification-select-all">
					<input
						type="checkbox"
						className="form-check-input notification-checkbox"
						id={`select-all`}
						value={isAllSelected || false}
						checked={isAllSelected || false}
						onChange={(ev) => onSelectAll(ev)}
					/>
					<label className="form-check-label notification-label" htmlFor={`select-all`}>
						Select all
					</label>
				</div>
				<div className="notifications-items-list">
					{portfolioSettings.notificationTypes?.map((notificationType) => (
						<div
							className="notification-item-row"
							key={`${instanceId.current}-${notificationType.id}`}
						>
							<input
								type="checkbox"
								className="form-check-input notification-checkbox"
								id={`${instanceId.current}-${notificationType.id}`}
								value={notificationsState[notificationType.id] || false}
								checked={notificationsState[notificationType.id] || false}
								onChange={(ev) => handleToggle(ev, notificationType.id)}
							/>
							<label
								className="form-check-label notification-label"
								htmlFor={`${instanceId.current}-${notificationType.id}`}
							>
								{getLabel(notificationType)}
							</label>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default AlertsList;
